/**
 * Countries and States Saga
 */

import * as actions from '../actions/countries';
import { pushNotification } from '../actions/notifications';
import {
  areCountriesAlreadyFetched,
  areCountryStatesAlreadyFetched,
  fetchCountriesAndPostalCodes,
  fetchStatesForCountry,
  getCountryList,
  getPostalCodes,
  getStateList,
} from '../helpers/countries';

import { effects as fx } from 'redux-saga';
import { Action } from 'typescript-fsa';
import { sagaAsyncActionWorkerFactory } from '../../utils/saga';

type FetchCountriesRequestAction = Action<IPromiseActionPayload<ICountryActionPayload>>;
type FetchStatesForCountryRequestAction = Action<IRequestFetchStatesForCountryActionPayload>;

export function* init() {
  yield fx.all([
    fx.call(watchForFetchCountries),
    fx.call(watchForFetchStatesForCountry),
  ]);
}

function* watchForFetchCountries() {
  while (true) {
    const { payload: { promise } }: FetchCountriesRequestAction = yield fx.take(actions.requestFetchCountries);
    const alreadyFetch = yield fx.select(areCountriesAlreadyFetched());
    if (!alreadyFetch) {
      try {
        const worker = sagaAsyncActionWorkerFactory<{}, ICountryActionPayload>(
          actions.fetchCountries,
          fetchCountriesAndPostalCodes,
        );
        const result: ICountryActionPayload = yield fx.call(worker, {});
        promise.resolve(result);
      } catch (error) {
        promise.reject(error);
        yield fx.put(pushNotification({
          message: `Error while fetching country list`,
          autoDismiss: false,
          state: 'error',
        }));
      }
    } else {
      promise.resolve({
        countries: yield fx.select(getCountryList),
        postalCodes: yield fx.select(getPostalCodes),
      });
    }
  }
}

function* watchForFetchStatesForCountry() {
  yield fx.takeEvery(actions.requestFetchStatesForCountry, processFetchStatesForCountry);
}

function* processFetchStatesForCountry({ payload: { country, promise } }: FetchStatesForCountryRequestAction) {
  const alreadyFetched = yield fx.select(areCountryStatesAlreadyFetched(country.code));
  if (!alreadyFetched) {
    try {
      const worker = sagaAsyncActionWorkerFactory<ICountry, ICountryStateActionPayload>(
        actions.fetchStatesForCountry,
        fetchStatesForCountry,
      );
      const result = yield fx.call(worker, country);
      promise.resolve(result);
    } catch (e) {
      promise.reject(e);
      yield fx.put(pushNotification({
        message: `Error while fetching states for \`${country.name}\``,
        autoDismiss: false,
        state: 'error',
      }));
    }
  } else {
    promise.resolve({
      states: yield fx.select(getStateList),
      countryId: country.code,
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/countries.ts